import React from 'react';

import Box from '@components/Restyle/Box';
import Icon from '@components/shared/Icon/Icon';

export const CheckBoxButton: React.FC<{
  checked: boolean;
  indeterminate?: boolean;
}> = ({ checked, indeterminate = false }) => {
  if (indeterminate && !checked) {
    return (
      <Box
        width={20}
        height={20}
        backgroundColor='greenSecondary'
        alignItems='center'
        justifyContent='center'
        borderRadius='xxxs'>
        <Box width={10} height={2} backgroundColor='white' />
      </Box>
    );
  }

  return checked ? (
    <Icon name='CheckBoxSelected' variant='m' color='white' disabled={false} />
  ) : (
    <Box
      width={20}
      height={20}
      borderWidth={2}
      borderColor='grey03'
      borderRadius='xxxs'></Box>
  );
};
